// ABOUTME: Small round source badge for news list items.
// ABOUTME: Shows the stockhub logo for stockhub news, the fulfilment logo (or warehouse icon fallback) for warehouse news.

import { Box } from "@mui/material";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import { ReactComponent as StockhubLogo } from "../../../../styles/svg/stockhub.svg";

const NewsSourceLogo = ({ source, logoUrl, size = 24 }) => (
    <Box
        sx={{
            width: size,
            height: size,
            borderRadius: "50%",
            overflow: "hidden",
            flexShrink: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#fff",
            border: "1px solid rgba(49, 65, 95, 0.15)",
            "& svg": { width: size - 8, height: size - 8 },
            "& img": { width: 1, height: 1, objectFit: "cover" },
        }}
    >
        {source === "warehouse" ? (
            logoUrl ? <Box component="img" src={logoUrl} alt="" /> : <WarehouseIcon sx={{ fontSize: size - 8 }} />
        ) : (
            // The stockhub logo is a full-bleed square; render it at circle size so the
            // wrapper's border-radius clips it round instead of floating a square inside.
            <StockhubLogo style={{ width: size, height: size, display: "block" }} />
        )}
    </Box>
);

export default NewsSourceLogo;
